import React, {useCallback, useState} from "react";
import Page from "../../components/Page";
import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Container, FormControl,
    Grid,
    TextField
} from "@material-ui/core";
import SearchableSelect from "../../components/SearchableSelect";
import {Autocomplete} from "@material-ui/lab";
import {CustomerTypeEnum, RoleIdEnum, useGetProductListQuery, useGetUserListQuery} from "../../generated/graphql";
import {HasRole, saveFile, saveFilePost, selectMapFn} from "../../common/Util";
import NotificationPopup from "../../common/NotificationPopup";
import {map} from "lodash";
import {CustomerTypeList, OrderItemTypeList, ProductOriginList} from "../../common/Constant";

export default () => {
    const productListQuery = useGetProductListQuery();
    const { loading, data, error } = useGetProductListQuery();
    const [reportInput, setReportInput] = useState<any>({})
    const [forecastInput, setForecastInput] = useState({})
    const userListQuery = useGetUserListQuery({ fetchPolicy: "cache-and-network" });
    const inputProps: any = {
        inputProps: {style: {textAlign: "center"}}, style: {margin: 10},
        variant: "outlined",
        onChange: ({target}) => {
            setReportInput({...reportInput, [target.id]: target.value})
        }
    }
    const forecastInputProps: any = {
        onChange: ({target}) => {
            setForecastInput({...forecastInput, [target.id]: target.value})
        }
    }
    const downloadReport = useCallback(async (reportInput) => {
        try {
            const {customerType, durationTo, durationFrom, costTo, costFrom, productOrigins} = reportInput
            await saveFilePost(`/reports/order-items-revenue`,
                "產業報表細項.xlsx", {
                    startDate: durationFrom,
                    endDate: durationTo,
                    amountMin: costFrom,
                    amountMax: costTo,
                    productOrigins,
                    customerType
                });
        } catch (e) {
            NotificationPopup.error(`遇到問題 ${e.message}`);
        }
    }, []);

    const downloadAggregateReport = useCallback(async (reportInput) => {
        try {
            const {customerType, durationTo, durationFrom, costTo, costFrom, productOrigins} = reportInput
            await saveFilePost(`/reports/order-items-revenue-by-industry`,
                "產業加總表.xlsx", {
                    startDate: durationFrom,
                    endDate: durationTo,
                    amountMin: costFrom,
                    amountMax: costTo,
                    productOrigins,
                    customerType
                });
        } catch (e) {
            NotificationPopup.error(`遇到問題 ${e.message}`);
        }
    }, []);
    const downloadForecastReport = useCallback(async (forecastInput, v2=false)=> {
        try {
            const route = v2 ? "/order-items/forecast-order-items-v2" : "/order-items/forecast-order-items";
            const {startDate, endDate, productIds, customerName, customerType, orderItemType
                , productOrigin, assignedSalesUserId, assigneeId} = forecastInput;
            let url = `${route}?startDate=${startDate}&endDate=${endDate}`;
            if (startDate==undefined || endDate==undefined) {
                NotificationPopup.error(`請選擇起迄日期。`);
                return;
            }
            if (productIds?.length>0) {
                url += `&products=${productIds.join(',')}`;
            }
            if (customerName) {
                url += `&customerName=${customerName}`;
            }
            if (customerType) {
                url += `&customerType=${customerType}`;
            }
            if (orderItemType) {
                url += `&orderItemType=${orderItemType}`;
            }
            if (productOrigin) {
                url += `&productOrigin=${productOrigin.toLowerCase()}`;
            }
            if (assignedSalesUserId) {
                url += `&assignedSalesUserId=${assignedSalesUserId}`;
            }
            if (assigneeId) {
                url += `&assigneeId=${assigneeId}`;
            }
            await saveFile(url, `forecast-${startDate}-${endDate}`);
        }
        catch (e) {
            NotificationPopup.error(`遇到問題 ${e.message}`);
        }
    }, [])
    return (
        <HasRole roles={[RoleIdEnum.Admin, RoleIdEnum.Finance]}>
        <Page title={"industry report page"}>
            <Container maxWidth={false} style={{padding: "30px"}}>
                <Box display="inline-block">
                    <Card>
                        <CardHeader title={"產業報表"}/>
                        <CardContent>
                            <FormControl style={{width: "100%"}}>
                                <SearchableSelect
                                    label={"選擇客戶類型"}
                                    options={[
                                        ...CustomerTypeList,
                                        {value: "all", label: "全部"},
                                    ]}
                                    value={reportInput.customerType}
                                    onChange={(value) => {
                                        setReportInput({...reportInput, "customerType": value})
                                    }}
                                />
                            </FormControl>
                            <Grid container direction={"column"}>
                                <Grid container direction={"row"} alignItems={"center"}>
                                    花費從
                                    <TextField {...inputProps} id={"costFrom"} type="number"></TextField>
                                    至
                                    <TextField {...inputProps} id={"costTo"} type="number"></TextField>
                                </Grid>

                                <Grid container direction={"row"} alignItems={"center"}>
                                    期間自
                                    <TextField {...inputProps} id={"durationFrom"} type="date"></TextField>
                                    至
                                    <TextField {...inputProps} id={"durationTo"} type="date"></TextField>
                                </Grid>
                            </Grid>
                            <FormControl style={{width: "100%"}}>
                                <SearchableSelect
                                    multiple
                                    label={"選擇產品原廠"}
                                    options={ProductOriginList}
                                    value={reportInput.productOrigins}
                                    onChange={(value) => {
                                        setReportInput({...reportInput, "productOrigins": value})
                                    }}
                                />
                            </FormControl>

                        </CardContent>
                        <CardActions style={{justifyItems: "center"}}>
                            <Button
                                variant={"contained"}
                                color={"primary"}
                                style={{marginTop: 10}}
                                onClick={() => downloadReport(reportInput)}
                            >
                                下載產業報表細項
                            </Button>
                            <Button
                                variant={"contained"}
                                color={"primary"}
                                style={{marginTop: 10}}
                                onClick={() => downloadAggregateReport(reportInput)}
                            >
                                下載產業加總表
                            </Button>

                        </CardActions>
                    </Card>
                    <br/>
                    <Card>
                        <CardHeader title={"Forecast報表"}/>
                        <CardContent>
                            <Grid container direction={"column"}>
                                <Grid container direction={"row"} alignItems={"center"}>
                                    期間從
                                    <TextField {...forecastInputProps} inputProps={{style: {textAlign: "center"}}}
                                               id={"startDate"} type="date" style={{margin: 10}} variant="outlined"/>
                                    至
                                    <TextField {...forecastInputProps} inputProps={{style: {textAlign: "center"}}}
                                               id={"endDate"} type="date" style={{margin: 10}} variant="outlined"/>
                                </Grid>
                                <TextField {...forecastInputProps} label={"客戶名稱"}  id={"customerName"}/>
                                <FormControl style={{width: "100%"}}>
                                    <SearchableSelect
                                        multiple
                                        label={"選擇產品"}
                                        options={data?.products.map(selectMapFn) ?? []}
                                        value={(forecastInput as any).productIds}
                                        onChange={(value) => {
                                            setForecastInput({...forecastInput, "productIds": value})
                                        }}
                                    />
                                </FormControl>
                                <FormControl style={{width: "100%"}}>
                                    <SearchableSelect
                                        label={"客戶類型"}
                                        options={CustomerTypeList}
                                        value={(forecastInput as any).customerType}
                                        onChange={(value) => {
                                            setForecastInput({...forecastInput, "customerType": value})
                                        }}
                                    />
                                </FormControl>

                                <FormControl style={{width: "100%"}}>
                                    <SearchableSelect
                                        label={"操作方式"}
                                        options={OrderItemTypeList}
                                        value={(forecastInput as any).orderItemType}
                                        onChange={(value) => {
                                            setForecastInput({...forecastInput, "orderItemType": value})
                                        }}
                                    />
                                </FormControl>

                                <FormControl style={{width: "100%"}}>
                                    <SearchableSelect
                                        label={"原廠商"}
                                        options={ProductOriginList}
                                        value={(forecastInput as any).productOrigin}
                                        onChange={(value) => {
                                            setForecastInput({...forecastInput, "productOrigin": value})
                                        }}
                                    />
                                </FormControl>
                                <FormControl style={{width: "100%"}}>
                                    <SearchableSelect
                                        label={"AE負責人"}
                                        options={userListQuery.data?.users.map(selectMapFn) ?? []}
                                        value={(forecastInput as any).assignedSalesUserId}
                                        onChange={(value) => {
                                            setForecastInput({...forecastInput, "assignedSalesUserId": value})
                                        }}
                                    />
                                </FormControl>
                                <FormControl style={{width: "100%"}}>
                                    <SearchableSelect
                                        label={"AM負責人"}
                                        options={userListQuery.data?.users.map(selectMapFn) ?? []}
                                        value={(forecastInput as any).assigneeId}
                                        onChange={(value) => {
                                            setForecastInput({...forecastInput, "assigneeId": value})
                                        }}
                                    />
                                </FormControl>

                            </Grid>
                        </CardContent>
                        <CardActions style={{justifyItems: "center"}}>
                            <Button
                                variant={"contained"}
                                color={"primary"}
                                style={{marginTop: 10}}
                                onClick={() => downloadForecastReport(forecastInput)}
                            >
                                下載Forecast報表
                            </Button>
                            <Button
                                variant={"contained"}
                                color={"primary"}
                                style={{marginTop: 10}}
                                onClick={() => downloadForecastReport(forecastInput, true)}
                            >
                                下載Forecast報表(不計算花費)
                            </Button>

                            {/*<Button*/}
                            {/*    variant={"contained"}*/}
                            {/*    color={"primary"}*/}
                            {/*    style={{marginTop: 10}}*/}
                            {/*    onClick={() => setForecastInput({})}*/}
                            {/*>*/}
                            {/*    重設*/}
                            {/*</Button>*/}
                        </CardActions>
                    </Card>
                </Box>
            </Container>
        </Page>
        </HasRole>
    )
}
